import { Stack } from 'expo-router';

import { useMqSelect } from '@fhs/ui';

import { MenuWebHeader } from '../../../components/menu-web-header';

export default function TabMenuWebLayout() {
  const isDesktopWeb = useMqSelect({ $gteDesktop: true }, false);

  return (
    <Stack>
      <Stack.Screen
        name="(menu)/index"
        options={{
          header: () => <MenuWebHeader />,
          headerShown: !isDesktopWeb,
          title: 'Menu',
        }}
      />
    </Stack>
  );
}
